<template>
  <div class="order__product">
    <div class="order__product-wrap">
      <div class="order__col">
        <div class="order__image-wrap">
          <figure class="order__image">
          <a :href="order.url">
            <img
              :src="order.img"
              :alt="order.name"
              width="50px"
              height="50px"
              loading="lazy"
            />
          </a> 
          </figure>
        </div>
        <p class="main-text text-bold order__sku">  <a :href="order.url">{{ order.sku }}</a></p>
        <p class="main-text"> <a :href="order.url">{{ order.name }}</a></p>
        <p
          v-for="specific in order.specifics"
          :key="specific.name"
          class="main-text"
        >
          {{ specific.name }}: {{ specific.value }}
        </p>
        <p v-if="order.misc6" class="main-text">Discount : 44%</p>
        <p v-if="order.misc5" class="main-text">
          Credit Value : {{ order.misc5 }}
        </p>
      </div>
      <div
        v-if="order.misc5 !== CANCELLED "
        class="order__btn-wrap"
      >
        <a
           v-if="order.misc4"
          :href="order.misc4"
          download
          target="_blank"
          class="btn btn-default jsDownloadImg"
        >
          Download
          <svg class="order__download">
            <use xlink:href="#icon-download-light"></use>
          </svg>
        </a>
        <a v-else :href="order.url" class="btn btn-default">
          Reorder
        </a>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import type { Order } from "./order";
interface Props {
  order: Order;
}

defineProps<Props>();

const CANCELLED = "Cancelled";
</script>